// extracted by mini-css-extract-plugin
var _1 = "#B9BCC0";
var _2 = "16px";
var _3 = "16px";
var _4 = "#FFEEEF";
var _5 = "#DB1A1A";
var _6 = "#00A0D1";
var _7 = "#0093BF";
var _8 = "#57BBE3";
var _9 = "#FCB03E";
var _a = "#28A842";
var _b = "#248538";
var _c = "#FF6998";
var _d = "#E8407B";
var _e = "#FF7C36";
var _f = "#ED702D";
var _10 = "#B0E2EE";
var _11 = "#B86BC9";
var _12 = "#9D52B0";
var _13 = "#18ccc6";
var _14 = "#00A6A0";
var _15 = "#F5F5F7";
var _16 = "#E1E3E6";
var _17 = "#B9BCC0";
var _18 = "#91959C";
var _19 = "#6F7378";
var _1a = "#2E3136";
var _1b = "#DBF7FF";
var _1c = "#0093BF";
var _1d = "#FCB03E";
var _1e = "#E8407B";
var _1f = "#28A842";
var _20 = "0 2px 12px rgba(0, 0, 0, 0.24)";
var _21 = "#0093BF";
var _22 = "#007699";
var _23 = "#00AAA5";
var _24 = "8px";
var _25 = "0 2px 2px rgba(0, 0, 0, 0.2)";
var _26 = "12px";
var _27 = "16px";
var _28 = "24px";
var _29 = "32px";
var _2a = "4px";
var _2b = "8px";
var _2c = "#E3FCD9";
var _2d = "#28A842";
var _2e = "#43C7DE";
var _2f = "#5AD7FD";
var _30 = "#FD5A5A";
var _31 = "#FFF0C7";
var _32 = "#ED702D";
var _33 = "#FFFFFF";
export { _1 as "borderColor", _2 as "contentMargin", _3 as "contentPadding", _4 as "errorBg", _5 as "errorColor", _6 as "eviteBlue", _7 as "eviteBlueDark", _8 as "eviteBlueLight", _9 as "eviteGold", _a as "eviteGreen", _b as "eviteGreenDark", _c as "eviteMagenta", _d as "eviteMagentaDark", _e as "eviteOrange", _f as "eviteOrangeDark", _10 as "eviteProBlue", _11 as "evitePurple", _12 as "evitePurpleDark", _13 as "eviteTeal", _14 as "eviteTealDark", _15 as "gray1", _16 as "gray2", _17 as "gray3", _18 as "gray4", _19 as "gray5", _1a as "gray6", _1b as "infoBg", _1c as "infoColor", _1d as "inviteMaybe", _1e as "inviteNo", _1f as "inviteYes", _20 as "largeShadow", _21 as "linkColor", _22 as "linkHoverColor", _23 as "pampersColor", _24 as "radius", _25 as "shadow", _26 as "spacing12", _27 as "spacing16", _28 as "spacing24", _29 as "spacing32", _2a as "spacing4", _2b as "spacing8", _2c as "successBg", _2d as "successColor", _2e as "virtualPartyBlue", _2f as "virtualPartyLightBlue", _30 as "virtualPartyRed", _31 as "warningBg", _32 as "warningColor", _33 as "white" }
